import semAlergologica from "./semAlergologica";
import semFisiatrica   from "./semFisiatrica";
import semOncologica   from "./semOncologica";
import semPediatrica   from "./semPediatrica";
import semCardiologica from "./semCardiologica";



export default {
  state: {
    lastSemiologia: null,
    semActual      : null,
    semPediatrica  : null,
    semFisiatrica  : null,
    semNutricional : null,
    semNeumologica : null,
    semOtorrino    : null,
    semUrologica   : null,
    semGastro      : null,
    semGineco      : null,
    semPsicologica : null,
    semOdontologica : null
  },

  mutations: {

    setLastSemiologia(state, data){
      state.lastSemiologia = data
    },

    setSemActual(state, data){
      state.semActual = { ...data }
    },

    setSemNutricional(state, data){
      state.semNutricional = data
    },

    setSemPsicologica(state, data){
      state.semPsicologica = { ...data }
    },

    setSemOdontologica(state, data){
      state.semOdontologica = { ...data }
    },

    setNeumologica(state, newData){
      state.semNeumologica = { ...state.semNeumologica, ...newData }
    },

    setOtorrino(state, newData){
      state.semOtorrino = { ...state.semOtorrino, ...newData }
    },

    setUrologica(state, newData){
      state.semUrologica = { ...state.semUrologica, ...newData }
    },

    setGastro(state, newData){
      state.semGastro = { ...state.semGastro, ...newData } 
    },

    setSemGineco(state, newData){
      state.semGineco = { ...state.semGineco, ...newData }
    },


    resetSemActual(state){
      state.semActual = null
    },

    resetLastSemiologia(state){
      state.lastSemiologia = null
    },
  },


  actions: {
    resetSemiologias({ commit }) {
      commit('resetSemActual');
      commit('resetLastSemiologia');
      commit('resetSemPediatrica');
    },
  },

  modules: {
    semAlergologica,
    semFisiatrica,
    semOncologica,
    semPediatrica,
    semCardiologica
  },

};
